// extracted by mini-css-extract-plugin
export default {"link":"bO-z","disabled":"cO-z"};